// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"6cb5ef66","345":"901440e6","674":"96dd8dc6","771":"6dc55f5d"}[chunkId] + ".chunk.js";
};